/**
 * @file HeaderSection.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Header component of manage-user.
 */
import { Breadcrumbs, Divider, Skeleton, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export const HeaderSection = ({ isLoading, id }) => {
  return (
    <>
      {isLoading ? (
        <Skeleton variant="rounded" width={180} height={24} />
      ) : (
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/users">Users</Link>
          <Typography sx={{ color: "text.primary" }}>
            {id === "new" || id === "" ? "Add New User" : "Edit User"}
          </Typography>
        </Breadcrumbs>
      )}
      {isLoading ? (
        <Skeleton sx={{ mt: 3 }} variant="rounded" width={390} height={24} />
      ) : (
        <Typography
          sx={{ mt: 2, mb: 0.5 }}
          fontWeight={700}
          fontSize={24}
          color="#222222"
        >
          Users
        </Typography>
      )}
      {!isLoading && <Divider />}
    </>
  );
};
